<template>
  <div class="footer-bar">
    <div class="container py-3">
      <div class="row pt-1 align-items-center">
        <div
          class="col-xl-6 col-md-6 col-sm-12 pbelow"
          style="color: white;"
        >
          <span>© {{ new Date().getFullYear() }} Usama Khurshid</span>
        </div>

        <div class="col-xl-6 col-md-6 col-sm-12">
          <div class="text-center">
            <a
              href="#"
              @click.prevent="open('linkedin')"
              class="btn btn-footer"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              href="#"
              @click.prevent="open('github')"
              class="btn btn-footer"
              aria-label="GitHub"
            >
              <i class="fab fa-github"></i>
            </a>
            <a
              v-if="website"
              href="#"
              @click.prevent="open('website')"
              class="btn btn-footer"
              aria-label="Website"
            >
              <i class="fas fa-globe"></i>
            </a>
            <a
              href="#"
              @click.prevent="open('resume')"
              class="btn btn-footer"
              aria-label="Resume"
            >
              <i class="fa fa-file-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import info from "../../info";

export default {
  name: "Footer",
  data() {
    return {
      linkedin: info.links.linkedin,
      github: info.links.github,
      website: info.links.website,
      resume: info.links.resume,
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "website":
          window.open(this.website, "_blank");
          break;
        case "resume":
          window.open(this.resume, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.footer-bar {
  background: var(--color-accent, #475569);
}

span {
  font-weight: 500;
  font-size: 0.95rem;
}

.btn-footer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin: 0 0.35rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  color: white;
  background: transparent;
  transition: all 0.25s ease;
}

.btn-footer:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: white;
  color: white;
}

.btn-footer:focus {
  outline: none;
  box-shadow: none;
}

@media screen and (max-width: 580px) {
  .pbelow {
    padding-bottom: 20px;
    text-align: center;
  }
}
</style>
